import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  MapContainer,
  TileLayer,
  GeoJSON,
  Marker,
  Popup,
  LayersControl,
  Pane,
  // WMS,
} from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import legenda from "./legenda-white.png";
import legendaZone30 from "./legenda-z30.png";
import legendaZtl from "./legenda-ztl.png";

import "leaflet/dist/leaflet.css";
import axios from "axios";
import {
  faAngleDoubleLeft,
  faArrowLeft,
  faChevronDown,
  // faArrowDown,
  // faEye,

  // faArrowCircleLeft,
  // faSearch,
  // faSearchLocation,
} from "@fortawesome/free-solid-svg-icons";
// import Control from 'react-leaflet-control';
import Control from "react-leaflet-custom-control";
import BetterWMS from "./components/icons/leaflet/BetterWMS";
import LayerButton from "./components/icons/controls/LayerButton";
import Measure from "./components/icons/leaflet/Measure/index.js";
import MapPrint from "./components/icons/leaflet/MapPrint/index.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { randomBytes, randomInt } from "crypto";

import logo from "./logo.svg";
import classNames from "classnames";
import ParcoSvg from "./components/icons/ParcoSvg";
import "./css/leaflet-greyscale.css";
import { categoryMap } from "./data/categoryMap";
import { emptyAreeVerdi } from "./data/emptyAreeVerdi";
import { icons, rackIcon, customIcon, nextBikeIcon } from "./data/icons";
// import next_bike from "./icons/marker-bigi.png";

// interface Category {
//   objectId: string;
//   value: string;
//   nome: string;
// }

// import 'react-leaflet-measure';
// import MeasureControl from 'react-leaflet-measure';

// function InfoOverlay({ infoRef, onClose, onShowInfo }) {
//   return (
//     <div
//       ref={infoRef}
//       className="fixed top-0 left-0 w-full bg-gray-800 text-white p-4 opacity-0 pointer-events-none transition-opacity duration-500"
//     >
//       <div className="flex justify-between items-center">
//         <p id="infoText"></p>
//         <button onClick={onClose} className="bg-red-500 px-3 py-1 rounded">
//           Chiudi
//         </button>
//       </div>
//     </div>
//   );
// }

function InfoOverlay({ infoRef, onClose }) {
  return (
    <div
      ref={infoRef}
      className="absolute bottom-24 left-0 w-full bg-white text-black p-4 opacity-0 pointer-events-none transition-opacity duration-500 info-overlay"
    >
      <div className="flex justify-between items-center">
        <p className="border-4 rounded-md border-red-600 px-2 py-2 text-xl text-black">
          ZTL
        </p>
        <div className="flex flex-col space-y-1">
          <p id="infoText" className="ml-2"></p>
        </div>
        <button
          onClick={onClose}
          className="bg-red-500 text-white px-3 py-1 rounded"
        >
          Chiudi
        </button>
      </div>
    </div>
  );
}

function Zone30Overlay({ zone30Ref, onClose }) {
  return (
    <div
      ref={zone30Ref}
      className="absolute bottom-0 left-0 w-full bg-white text-black p-4 opacity-0 pointer-events-none transition-opacity duration-500 info-overlay"
    >
      <div className="flex justify-between items-center">
        <p className="border-4 rounded-md border-red-600 px-2 py-2 text-xl text-black">
          Zona 30
        </p>
        <div className="flex flex-col space-y-1">
          <p id="zone30Text" className="ml-2"></p>
        </div>
        <button
          onClick={onClose}
          className="bg-red-500  text-white px-3 py-1 rounded"
        >
          Chiudi
        </button>
      </div>
    </div>
  );
}

function MapComponent(props) {
  const [nextBikeCluster, setNextBikeCluster] = useState([]);

  const [areeVerdiEnabled, setAreeVerdiEnabled] = useState(
    "areeVerdiNotEnabled"
  );
  const [areeVerdi, setAreeVerdi] = useState(emptyAreeVerdi);

  // const [zone30, setZone30] = useState(emptyAreeVerdi);
  const [zone30Enabled, setZone30Enabled] = useState(false);
  const [ztlEnabled, setZtlEnabled] = useState(false);

  const [activeLayer, setActiveLayer] = useState("openstreetmap");

  const removeRastrelliereParse = useCallback(() => {
    setRastrelliereCluster([]);
  }, []);

  const getRastrelliereParse = useCallback(async () => {
    const headers = {
      "X-Parse-Application-Id": "wWB2Mfa7R0Bc8y0iEiDb6LmjiafHzM61s1jOYsWj",
      "X-Parse-REST-API-Key": "psTwhoOemyqG4HT3LlVoRqrCcXgNT10tJtbiyI8L",

      // "X-App-Token": "FBKnSfwSAamg8UcmiqejRe4et",
    };
    axios
    ({
      method: 'GET',
      url: `https://parseapi.back4app.com/classes/Rastrelliera?limit=10000`,
      // url: `https://www.dati.lombardia.it/resource/uqru-7gbz.json?$limit=500`,
        headers: headers,
        withCredentials: false,

        // params: {
        //   status: "CLOSED",
        //   "$$app_token": "FBKnSfwSAamg8UcmiqejRe4et"
        // }
      }
    )

      
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          // if (!mapRef.current) return;
          const results = res.data.results.map((f) => {
            // console.log(f);
            return {
              id_ras: f.id_ras,
              latitude: f.latitude,
              longitude: f.longitude,
              stalli: f.stalli,
              stato_uso: f.stato_uso,
              tipologia: f.tipologia,
            };
          });

          // console.log(results);

          setRastrelliereCluster(results);
        }
      })
      .catch((e) => {
        // console.log("ERRORE", e);
      });
  }, []);

  const removeNextBike = useCallback(() => {
    // if (!mapRef.current) return;
    setNextBikeCluster([]);
  }, []);
  const [rastrelliereCluster, setRastrelliereCluster] = useState([]);

  const getNextBike = useCallback(async () => {
    const headers = {
      "X-Parse-Application-Id": "wWB2Mfa7R0Bc8y0iEiDb6LmjiafHzM61s1jOYsWj",
      "X-Parse-REST-API-Key": "psTwhoOemyqG4HT3LlVoRqrCcXgNT10tJtbiyI8L",
      // "X-App-Token": "FBKnSfwSAamg8UcmiqejRe4et",
      "Content-Type": 'application/json'
    };
    axios

      ({
        method: 'GET',
        url: `https://parseapi.back4app.com/classes/NextBike?limit=10000`,
        // url: `https://www.dati.lombardia.it/resource/uqru-7gbz.json?$limit=500`,
          headers: headers,
          withCredentials: false,

          // params: {
          //   status: "CLOSED",
          //   "$$app_token": "FBKnSfwSAamg8UcmiqejRe4et"
          // }
        }
      )
      .then((res) => {
        if (res.data) {
          setNextBikeCluster(res.data.results);
        }
      })
      .catch((e) => {
        console.log("ERRORE", e);
      });
  }, []);

  const getZtl = useCallback(async () => {
    // setZone30(zone30RemoteData );
    setZtlEnabled(true);
  }, []);

  const removeZtl = useCallback(() => {
    // setZone30(emptyAreeVerdi);
    setZtlEnabled(false);
  }, []);

  const getZone30 = useCallback(async () => {
    // setZone30(zone30RemoteData );
    setZone30Enabled(true);
  }, []);

  const removeZone30 = useCallback(() => {
    // setZone30(emptyAreeVerdi);
    setZone30Enabled(false);
  }, []);

  const [areeVerdiRemoteData, setAreeVerdiRemoteData] = useState();

  const getGreenArea = useCallback(() => {
    console.log(" get green");

    if (!areeVerdiRemoteData) {
      const headers = {
        "X-Parse-Application-Id": "wWB2Mfa7R0Bc8y0iEiDb6LmjiafHzM61s1jOYsWj",
        "X-Parse-REST-API-Key": "psTwhoOemyqG4HT3LlVoRqrCcXgNT10tJtbiyI8L",
      };
      axios

        .get(
          `https://parseapi.back4app.com/classes/Feature?where={"name":"areeVerdi"}`,
          { headers: headers }
        )
        .then((res) => {
          if (res.data !== null && res.data.results.length > 0) {
            const data = res.data.results[0].data;
            setAreeVerdiRemoteData(data);
            // console.log(res.data);

            setAreeVerdi(data);
            setAreeVerdiEnabled("areeVerdiEnabled");

            // setNextBikeCluster(res.data.results);
          }
        })
        .catch((e) => {
          // console.log("ERRORE", e);
        });
    } else {
      setAreeVerdi(areeVerdiRemoteData);
      setAreeVerdiEnabled("areeVerdiEnabled");
    }
  }, [areeVerdiRemoteData]);
  const [showBiciPlanLegend, setShowBiciPlanLegend] = useState(true);

  const removeGreenArea = useCallback(() => {
    console.log(" remove green");

    setAreeVerdi(emptyAreeVerdi);
    setAreeVerdiEnabled("areeVerdiNotEnabled");
  }, []);

  const onEachFeature = useCallback((feature, layer) => {
    layer.options.color = "black";
    layer.options.fillOpacity = 1;
    layer.options.weight = 1;
    layer.options.dashArray = 1;
    layer.options.opacity = 1;

    layer.bindPopup(
      '<div class="border border-black "><h1 class="bg-black h-8  text-base text-white font-semibold p-1">Area Verde</h1></br>' +
        `<div class="p-1 py-2">${feature.properties.Localita_n}<br/><br/>` +
        "<strong>Tipologia</strong>: " +
        feature.properties.tipo_verde +
        "<br/>" +
        "<strong>Area</strong>: " +
        feature.properties.area_mq +
        " mq<br/><strong>Perimetro</strong>: " +
        feature.properties.perim_m +
        " m</div>"
    );
    layer.on({
      // mouseover: this.onMouseOver,
      // mouseout: this.onMouseOut,
      // click: onMouseClick
    });
  }, []);
  return (
    <>
      {/* </LayersControl> */}
      <LayersControl position="bottomleft">
        <LayersControl.BaseLayer checked name="OpenStreetMap">
          <TileLayer
            checked
            eventHandlers={{
              add: (e) => {
                // console.log("cyclemap added", e);
                // setShowLegend(true);
                console.log(activeLayer);
                if (activeLayer !== "openstreetmap") {
                  setActiveLayer("openstreetmap");
                }
              },
              remove: (e) => {
                console.log(activeLayer);
                if (activeLayer === "openstreetmap") {
                  setActiveLayer("balck&white");
                }
              },
            }}
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            crossOrigin={true}
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            className={"toGrey"}
          />
        </LayersControl.BaseLayer>
        {/* <LayersControl.BaseLayer name="Black&White">
          <TileLayer
            attribution='&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a>'
            url="https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.jpg"
          />
        </LayersControl.BaseLayer> */}
        <LayersControl.BaseLayer name="Ortofoto2023">
          <TileLayer
            attribution='&copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a>'
            url="http://territorio.comune.bergamo.it/arcgis/rest/services/AtlanteBG/Ortofoto2023_CGR_WGS84webmercator/MapServer/WMTS/tile/1.0.0/AtlanteBG_Ortofoto2023_CGR_WGS84webmercator/default/GoogleMapsCompatible/{z}/{y}/{x}"
          />
        </LayersControl.BaseLayer>
      </LayersControl>

      {ztlEnabled ? (
        <BetterWMS
          // key={activeLayer + ztlEnabled}
          layers={["0", "1", "2", "3", "5"]} // "7", "6"]}
          options={{
            opacity: 0.7,
            zIndex: 1010,
            transparent: true,
            format: "image/png8",
            info_format: "application/json",
          }}
          onShow={(testo) => {
            console.log("onShow");
            console.log(props);

            props.onShowInfo(testo);
          }}
          url={
            "https://territorio.comune.bergamo.it/arcgis/services/AtlanteBG/ZTL/MapServer/WMSServer?"
          }
        ></BetterWMS>
      ) : null}

      {zone30Enabled ? (
        <BetterWMS
          // key={activeLayer + ztlEnabled}
          // layers={[
          //   "0",
          //   "1",
          //   "2",
          //   "3",
          //   "5",
          //   "6",
          //   "7",
          //   "8",
          //   "9",
          //   "10",
          //   "11",
          //   "12",
          // ]} // "7", "6"]}
          version="1.1.0"
          layers={[
            "0",
            "1",
            "2",
            // "3",
            // "4",
            // "BGinBicicletta_Zone30",
            // "BGinBicicletta_20",
            // "BGinBicicletta_10",
            // "5",
            // "6",
            // "7",
            // "8",
            // "9",
            // "10",
            // "11",
            // "12",
          ]} // "7", "6"]}
          options={{
            opacity: 0.7,
            zIndex: 1014,
            transparent: true,
            format: "image/png8",
            info_format: "application/geojson",
            version: "1.1.0",
            // version: "1.3.0",
          }}
          onShow={(testo) => {
            console.log("onShow");
            console.log(props);
            props.onShowZone30(testo);
          }}
          url={
            // "https://territorio.comune.bergamo.it/arcgis/services/AtlanteBG/Zone30_20_10_test_BGinBicicletta/MapServer/WMSServer?"
            "https://territorio.comune.bergamo.it/arcgis/services/AtlanteBG/Zone30_20_10/MapServer/WMSServer?"
          }
        ></BetterWMS>
      ) : null}


      <BetterWMS
        // key={activeLayer + ztlEnabled}
        // layers={["0", "1", "2", "3", "5", "4", "7", "6", "8"]} // "7", "6"]}
        layers={["0", "1", "2", "3", "5", "4", "6", "8"]} // "7", "6"]}
        options={{
          opacity: 1,
          zIndex: 1016,
          transparent: true,
          format: "image/png8",
          info_format: "text/plain",
          version: "1.1.1",
        }}
        pane="ciclabile"
        // onEachFeature={doSomethink}
        url={
          "https://territorio.comune.bergamo.it/arcgis/services/AtlanteBG/BGinBicicletta_ReteCiclabile/MapServer/WMSServer?"
        }
      ></BetterWMS>

      <GeoJSON
        data={areeVerdi}
        pane="customPane"
        key={areeVerdiEnabled}
        onEachFeature={onEachFeature}
        style={{
          fillColor: "#00aa0055",
          // zIndex: 100002,
        }}
        // zIndex={100002}
      />
     

      <Control position="topleft">
        <LayerButton
          type={"biking"}
          label="Stazioni della BiGi"
          // enabled={false}
          onEnable={getNextBike}
          onDisable={removeNextBike}
        />
      </Control>
      <Control position="topleft">
        <LayerButton
          type={"bike_rack"}
          label="Rastrelliere"
          // enabled={false}
          // onEnable={getRastrelliere}
          // onDisable={removeRastrelliere}
          onEnable={getRastrelliereParse}
          onDisable={removeRastrelliereParse}
        />
      </Control>
      <Control position="topleft">
        <LayerButton
          label="zone30"
          type={"zone30"}
          // enabled={zone30Enabled === "zone30Enabled"}
          onEnable={getZone30}
          onDisable={removeZone30}
        />
      </Control>

      <Control position="topleft">
        <LayerButton
          type={"green_area"}
          label="Aree Verdi"
          // enabled={false}
          onEnable={getGreenArea}
          onDisable={removeGreenArea}
          // onEnable={getGreenArea}
          // onDisable={removeGreenArea}
        />
      </Control>
      <Control position="topleft">
        <LayerButton
          label="ZTL"
          type={"ztl"}
          // enabled={ztlEnabled === "ztlEnabled"}
          onEnable={getZtl}
          onDisable={removeZtl}
        />
      </Control>

      <Control position="topright">
        <div
          className="info"
          // className={classNames(
          //   showBiciPlanLegend
          //     ? "opacity-100 w-32 md:w-48"
          //     : "opacity-0 w-0",
          //   "transition-all ease-in-out duration-200 space-y-2 px-2 pb-2 md:text-xs  text-xxs  w-32  md:w-48 flex flex-col bg-white text-black x§1"
          // )}
        >
          <div className={"relative"}>
            <span
              className={classNames(
                !showBiciPlanLegend ? " -rotate-0 " : "rotate-180",
                "text-black  top-2 right-4 absolute transition-all  ease-in-out duration-200  "
              )}
              onClick={() => {
                setShowBiciPlanLegend(!showBiciPlanLegend);
              }}
            >
              <FontAwesomeIcon
                icon={faChevronDown}
                size="lg"
                // className={classNames(
                //   showBiciPlanLegend ? "  " : "rotate-90",
                //   "text-black  transition-all ease-in-out duration-200 "
                // )}
              />
            </span>
            {showBiciPlanLegend ? (
              <img
                className={classNames(
                  showBiciPlanLegend
                    ? "opacity-100 w-32 md:w-48"
                    : "opacity-0 w-0",
                  "transition-all ease-in-out duration-200 space-y-2 px-2 pb-2 md:text-xs  text-xxs  w-32  md:w-48 flex flex-col bg-white text-black "
                )}
                src={legenda}
                alt="legenda"
              />
            ) : (
              <div
                className={classNames(
                  !showBiciPlanLegend
                    ? "opacity-100 w-32 md:w-32"
                    : "opacity-0 w-0",
                  "transition-all ease-in-out duration-200 pt-2 space-y-2 px-2 w-16 md:w-24 h-8 text-xs bg-white font-semibold"
                )}
              >
                Legenda
              </div>
            )}
          </div>
          {/* <div className="w-12 lg:w-16 md:w-14  h-2 border-dashed border-t-2  border-b-2 mt-3 border-blue-600  "></div>
                      <div className="text-xxs">
                        Corsie ciclabili emergenziali
                      </div>
                      <div className="w-12 lg:w-16  md:w-14  h-1 bg-blue-600 border-t-2 border-b-2 border-blue-600  "></div>
                      <div className="text-xxs">Inter connessione</div> */}
          {/* <div className="absolute -top-2 right-1 w-3 h-3 text-base rounded bg-white">
                      x
                    </div> */}
        </div>
      </Control>
      <Control position="topright">
        <div
          className="info"
          // className={classNames(
          //   showBiciPlanLegend
          //     ? "opacity-100 w-32 md:w-48"
          //     : "opacity-0 w-0",
          //   "transition-all ease-in-out duration-200 space-y-2 px-2 pb-2 md:text-xs  text-xxs  w-32  md:w-48 flex flex-col bg-white text-black x§1"
          // )}
        >
          <div className={"relative"}>
            {zone30Enabled ? (
              <img
                className={classNames(
                  zone30Enabled ? "opacity-100 w-32 md:w-48" : "opacity-0 w-0",
                  "transition-all ease-in-out duration-200 space-y-2 px-2 pb-2 md:text-xs  text-xxs  w-32  md:w-48 flex flex-col bg-white text-black "
                )}
                src={legendaZone30}
                alt="legenda"
              />
            ) : null}
          </div>
          <div className={"relative"}>
            {ztlEnabled ? (
              <img
                className={classNames(
                  ztlEnabled ? "opacity-100 w-32 md:w-48" : "opacity-0 w-0",
                  "transition-all ease-in-out duration-200 space-y-2 px-2 pb-2 md:text-xs  text-xxs  w-32  md:w-48 flex flex-col bg-white text-black "
                )}
                src={legendaZtl}
                alt="legenda"
              />
            ) : null}
          </div>
          {/* <div className="w-12 lg:w-16 md:w-14  h-2 border-dashed border-t-2  border-b-2 mt-3 border-blue-600  "></div>
                      <div className="text-xxs">
                        Corsie ciclabili emergenziali
                      </div>
                      <div className="w-12 lg:w-16  md:w-14  h-1 bg-blue-600 border-t-2 border-b-2 border-blue-600  "></div>
                      <div className="text-xxs">Inter connessione</div> */}
          {/* <div className="absolute -top-2 right-1 w-3 h-3 text-base rounded bg-white">
                      x
                    </div> */}
        </div>
      </Control>
      <Measure
        position="topleft"
        primaryLengthUnit="meters"
        secondaryLengthUnit="kilometers"
        primaryAreaUnit="sqmeters"
        activeColor="#C63926"
        completedColor="#C63926"
      />
      <MapPrint
        position="topleft"
        sizeModes={[
          "Current",
          {
            width: 1492,
            height: 902,
            className: "a3CssClass",
            tooltip: "BgInBc",
          },
        ]}
        // tileLayer={L.tileLayer(
        //   "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
        //   {
        //     attribution:
        //       '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        //   }
        // )}
        hideControlContainer={false}
        title="Stampa"
        exportOnly={false}
        spinnerBgColor="C63926"
      />

      {/* <GeoJSON
        data={areeVerdi}
        key={areeVerdiEnabled}
        onEachFeature={onEachFeature}
        style={{
          fillColor: "#00aa0055",
          zIndex: 100002,
        }}
      /> */}
      <MarkerClusterGroup chunkedLoading>
        {rastrelliereCluster.map((next) => {
          return (
            <Marker
              key={next.id_ras}
              position={[next.latitude, next.longitude]}
              title={next.stalli + ""}
              icon={rackIcon}
            >
              <Popup>
                <div class="border border-black ">
                  <h1 class="bg-black h-8  text-base text-white font-semibold p-1">
                    Rastrelliera
                  </h1>
                  <br />
                  <div className="ml-1">
                    <strong>Tipologia:</strong> {next.tipologia}
                  </div>
                  <div className="ml-1">
                    <strong> Numero posti: </strong> {next.stalli}
                  </div>
                  <div className="ml-1">
                    <strong>Latitudine:</strong> {next.latitude}
                  </div>
                  <div className="ml-1">
                    <strong>Longitudine:</strong> {next.longitude}
                  </div>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MarkerClusterGroup>
      <MarkerClusterGroup chunkedLoading>
        {nextBikeCluster.map((next) => {
          return (
            <Marker
              key={next.id_staz}
              position={[next.latitude, next.longitude]}
              title={next.indirizzo}
              icon={nextBikeIcon}
            >
              <Popup>
                <div class="border border-black ">
                  <h1 class="bg-black h-8  text-base text-white font-semibold p-1">
                    BiGi
                  </h1>
                  <br />
                  <div className="ml-1"> {next.indirizzo}</div>
                  <br />
                  <div className="ml-1">
                    <strong> Numero bici: </strong> {next.n_bici}
                  </div>
                  {next.note ? (
                    <div className="ml-1 ">
                      <strong>Note:</strong> {next.note}
                    </div>
                  ) : null}
                  <div className="ml-1">
                    <strong>Latitudine:</strong> {next.latitude}
                  </div>
                  <div className="ml-1">
                    <strong>Longitudine:</strong> {next.longitude}
                  </div>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MarkerClusterGroup>
    </>
  );
}

const position = [45.6942, 9.6685];

function App() {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const mapRef = useRef();
  useEffect(() => {
    if (mapRef.current !== null) {
      // mapRef.current.
      // getRastrelliere();
    }
  }, []);
  const [pois, setPois] = useState([]);
  const [filter, setFilter] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currentPois, setCurrentPois] = useState([]);

  // const showInfoZtl = useCallback((info) => {

  // }, []);

  const toggleCategory = useCallback(
    async (category, category_id) => {
      if (filter.includes(category)) {
        // if(categories.includes(category)) {
        setCurrentPois([
          ...currentPois.filter((poi) => {
            return poi.category_id !== categoryMap[category].objectId;
          }),
        ]);
        // }

        setFilter([...filter.filter((cat) => cat !== category)]);
      } else {
        const newFilter = [...filter, category];
        if (categories.includes(category)) {
          setCurrentPois([
            ...currentPois,
            ...pois.filter((p) => p.category_value === category),
          ]);
          setFilter(newFilter);
        } else {
          const headers = {
            "X-Parse-Application-Id":
              "wWB2Mfa7R0Bc8y0iEiDb6LmjiafHzM61s1jOYsWj",
            "X-Parse-REST-API-Key": "psTwhoOemyqG4HT3LlVoRqrCcXgNT10tJtbiyI8L",
          };
          axios

            .get(
              `https://parseapi.back4app.com/classes/Poi?limit=10000&&where={"category":{"__type": "Pointer","className":"Category","objectId":"${category_id}"}}&&include="category"`,
              { headers: headers }
            )
            .then((res) => {
              if (res.data) {
                // if (!mapRef.current) return;
                const results = res.data.results.map((obj) => {
                  return {
                    ...obj,
                    category_value: obj.category.value,
                    category_id: obj.category.objectId,
                    category_name: obj.category.nome,
                  };
                });

                const newCategories = [...categories, category];
                setPois([...pois, ...results]);
                setCurrentPois([...currentPois, ...results]);
                setFilter(newFilter);
                setCategories(newCategories);
              }
            })
            .catch((e) => {});
        }
      }
    },
    [categories, currentPois, filter, pois]
  );

  const infoRef = useRef(null);

  const zone30Ref = useRef(null);

  return (
    <div className="flex h-screen flex-col relative">
      {/* Barra fissa in alto */}

      <div className="bg-secondary  sticky z-1001 top-0 h-20 flex items-center justify-between">
        <button
          className="ml-4 w-10 h-10 bg-primary rounded-full"
          type="button"
          aria-label="torna al sito bergamo in biciletta"
          onClick={() => {
            window.open("https://bergamoinbicicletta.it/", "_self");
          }}
        >
          <FontAwesomeIcon
            className={"text-secondary w-5 h-5 "}
            size="2x"
            icon={faArrowLeft}
          />
        </button>
        <img src={logo} alt="bergmao-in-bicicletta-logo" className="w-24" />
        <div></div>
      </div>
      <div className="flex flex-row overflow-hidden">
        <div className="w-full  max-h-full relative">
          <MapContainer
            center={position}
            zoom={14}
            tap={false}
            // dragging={false}
            scrollWheelZoom={true}
            whenCreated={(mapInstance) => {
              mapRef.current = mapInstance;

              if (mapRef.current) {
                // getRastrelliere();
                // getPiste();
                // getNextBike();
                // getRastrelliereParse();
                // getPisteNew();

                mapRef.current.on("measurestart", function (evt) {
                  // writeResults(evt);
                  console.log("measure started", evt);
                  // setLegendVisible(false)
                });
                mapRef.current.on("measurefinish", function (evt) {
                  // writeResults(evt);
                  console.log("measure finished", evt);
                  // setLegendVisible(true)
                });
              }
            }}
            className="h-full"
          >
            <Pane name="ciclabile" style={{ zIndex: 1010 }} />
            <Pane name="customPane" style={{ zIndex: 1000 }} />
            {/* <Pane name="customPane" style={{ zIndex: 100002 }} />
            <Pane name="customPane" style={{ zIndex: 100002 }} /> */}
            <MapComponent
              onShowZone30={(info) => {
                console.log("showZone30", info);

                const infoText = document.getElementById("zone30Text");

                // Mostra il riquadro informativo

                if (info == null) {
                  zone30Ref.current.classList.remove("opacity-100");
                  zone30Ref.current.classList.add(
                    "opacity-0",
                    "pointer-events-none"
                  );
                } else {
                  infoText.textContent = info;

                  zone30Ref.current.classList.remove(
                    "opacity-0",
                    "pointer-events-none"
                  );
                  zone30Ref.current.classList.add("opacity-100");
                  zone30Ref.current.classList.add("z-index-100000");

                  // Chiudi automaticamente dopo 5 secondi
                  setTimeout(() => {
                    zone30Ref.current.classList.remove("opacity-100");
                    zone30Ref.current.classList.add(
                      "opacity-0",
                      "pointer-events-none"
                    );
                  }, 10000);
                }
              }}
              onShowInfo={(info) => {
                console.log("showInfo", info);

                const infoText = document.getElementById("infoText");

                // Mostra il riquadro informativo

                if (info == null) {
                  infoRef.current.classList.remove("opacity-100");
                  infoRef.current.classList.add(
                    "opacity-0",
                    "pointer-events-none"
                  );
                } else {
                  infoText.textContent = info;

                  infoRef.current.classList.remove(
                    "opacity-0",
                    "pointer-events-none"
                  );
                  infoRef.current.classList.add("opacity-100");
                  infoRef.current.classList.add("z-index-100000");

                  // Chiudi automaticamente dopo 5 secondi
                  setTimeout(() => {
                    infoRef.current.classList.remove("opacity-100");
                    infoRef.current.classList.add(
                      "opacity-0",
                      "pointer-events-none"
                    );
                  }, 10000);
                }
              }}
            />
            <MarkerClusterGroup chunkedLoading>
              {currentPois.map((next) => {
                console.log("POIS", next);
                return (
                  <Marker
                    key={next.objectId}
                    position={[next.longitude, next.latitude]}
                    title={next.nome}
                    icon={
                      icons[next.category_value]
                        ? icons[next.category_value]
                        : customIcon
                    }

                    // icon={nextBikeMarkerIcon}
                  >
                    <Popup>
                      <div class="border border-black ">
                        <h1 class="bg-black h-8  text-base text-white font-semibold p-1">
                          {next.category.nome}
                        </h1>
                        <br />
                        <div className="ml-1"> {next.nome}</div>
                        <br />

                        {next.indirizzo !== "" && next.indirizzo !== null ? (
                          <div className="ml-1 ">
                            <strong>Indirizzo:</strong> {next.indirizzo}
                          </div>
                        ) : null}
                        {next.abstract !== "" && next.abstract !== null ? (
                          <div className="ml-1 ">{next.abstract}</div>
                        ) : null}
                        {next.gestione !== "" && next.gestione !== null ? (
                          <div className="ml-1 ">
                            <strong>Gestione:</strong> {next.gestione}
                          </div>
                        ) : null}
                        {next.contact_website !== "" &&
                        next.contact_website !== null ? (
                          <div className="ml-1 ">
                            <strong>Sito web:</strong>{" "}
                            <a href={next.contact_website} target="blank">
                              {next.contact_website}
                            </a>
                          </div>
                        ) : null}
                        {next.quartiere !== "" && next.quartiere !== null ? (
                          <div className="ml-1 ">
                            <strong>Quartiere:</strong> {next.quartiere}
                          </div>
                        ) : null}
                        <div className="ml-1">
                          <strong>Latitudine:</strong> {next.latitude}
                        </div>
                        <div className="ml-1">
                          <strong>Longitudine:</strong> {next.longitude}
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                );
              })}
            </MarkerClusterGroup>
          </MapContainer>
          <InfoOverlay
            infoRef={infoRef}
            onClose={(e) => {
              e.preventDefault();
              infoRef.current.classList.remove("opacity-100");
              infoRef.current.classList.add("opacity-0", "pointer-events-none");
            }}
          />

          <Zone30Overlay
            zone30Ref={zone30Ref}
            onClose={(e) => {
              e.preventDefault();
              zone30Ref.current.classList.remove("opacity-100");
              zone30Ref.current.classList.add(
                "opacity-0",
                "pointer-events-none"
              );
            }}
          />
        </div>
        <div
          className={classNames(
            menuIsOpen ? "   w-72 " : " w-6",
            "transition-all ease-in-out duration-300 flex flex-row max-h-full items-start justify-center bg-primary "
          )}
        >
          <div
            // onDragExit={() => {
            //   setMenuIsOpen(!menuIsOpen);
            // }}
            id="menu"
            className={
              "h-screen  w-6 transition-all duration-300 z-1000 items-center  justify-center bg-primary   overscroll-visible flex flex-col "
            }
          >
            <button
              type="button"
              id="menuIcon"
              onClick={() => {
                setMenuIsOpen(!menuIsOpen);
              }}
              className={
                "w-12  h-12 border-0  leading-none relative left-0 outline-none mr-4 transition-all duration-300  z-1001 bg-primary rounded-full  p-2"
              }
            >
              <FontAwesomeIcon
                className={classNames(
                  menuIsOpen ? "   rotate-180  " : " rotate-0 ",
                  "transform  transition duration-300 text-secondary ease-in-out "
                )}
                size="2x"
                icon={faAngleDoubleLeft}
              />
              <span className="visually-hidden">Menu</span>
            </button>
          </div>
          <div
            className={classNames(
              menuIsOpen ? "opacity-100 delay-500 w-44" : "opacity-0 w-44",
              "overflow-y-scroll scrollbar-hide flex-grow justify-betwwen pb-24 z-50 px-2 transition-all py-1 ease-in-out duration-300   max-h-full  mt-8 space-y-3 items-center"
            )}
          >
            {Object.keys(categoryMap).map((key, index) => {
              let obj = categoryMap[key];

              return (
                <div
                  key={obj.objectId}
                  className="inline-flex items-center align-middle w-full  rounded-full ring-1 ring-secondary "
                  onClick={(e) => {
                    e.preventDefault();
                    toggleCategory(obj.value, obj.objectId);
                  }}
                >
                  <p
                    className={classNames(
                      filter.includes(obj.value)
                        ? `text-primary  bg-secondary `
                        : ` text-secondary  bg-primary   `,
                      `transition-all  w-full h-7  uppercase ease-linear duration-150 items-center p-1 inline-flex space-x-2 px-3  text-xs align-middle font-bold rounded-full  `
                    )}
                  >
                    {!["amenity_music_school"].includes(obj.value) ? (
                      // <img
                      //   className={classNames(
                      //     !filter.includes(obj.value)
                      //       ? " text-secondary"
                      //       : "text-primary",
                      //     "transition-all duration-300 ease-in-out w-5 mr-2 "
                      //   )}
                      //   src={require(`./icons/${obj.value}.svg`)?.default}
                      //   alt={obj.nome}
                      // />
                      <ParcoSvg
                        type={obj.value}
                        className={classNames(
                          !filter.includes(obj.value)
                            ? " text-secondary"
                            : "text-primary",
                          "transition-all duration-300 ease-in-out w-4 mr-2 "
                        )}
                      />
                    ) : null}
                    {obj.nome}
                  </p>
                </div>
              );
            })}
          </div>
          {/* </div> */}
        </div>
      </div>
      {/* <Modal /> */}
    </div>
  );
}

export default App;
